let baseVars = require('./base.js').default
// if (process.env.VUE_APP_ENV === 'localprod') {
//   // 本地部署域名覆盖
//   const locals = require('./local.js').default
//   baseVars = { ...baseVars, ...locals }
// }
console.log(baseVars);
export const commonParams = {
  AI_WEB: baseVars.AI_WEB,
  API_HOST: baseVars.API_HOST,
  CONFIG_API_HOST: baseVars.CONFIG_API_HOST,
  COURSE_API_HOST: baseVars.COURSE_API_HOST,
  QINIU_RESOURCE_URL: baseVars.QINIU_RESOURCE_URL,
  UPBASETORKEN_URL: baseVars.UPBASETORKEN_URL,
  UPRESOURCE_URL: baseVars.UPRESOURCE_URL,
  HOMEWORKLIST_HOST: baseVars.HOMEWORKLIST_HOST,
  STUHOMEWORKLIST_HOST: baseVars.STUHOMEWORKLIST_HOST,
  BASE64_SAVEURL: baseVars.BASE64_SAVEURL,
  VIDEO_CONVERTADDR: baseVars.VIDEO_CONVERTADDR,
  DOCCONVERSIONURL: baseVars.DOCCONVERSIONURL,
  DOCS_HOST: baseVars.DOCS_HOST,
  UA_API_HOST: baseVars.UA_API_HOST,
  UMOOC_COOKIE_DOMAIN: baseVars.UMOOC_COOKIE_DOMAIN,
  UPLOAD_SERVER_HOST: baseVars.UPLOAD_SERVER_HOST,
  UPLOAD_SERVER_PROTOCOL: baseVars.UPLOAD_SERVER_PROTOCOL,
  SELFWORK_WEB_HOST:baseVars.SELFWORK_WEB_HOST,
  GROUPWORK_WEB_HOST:baseVars.GROUPWORK_WEB_HOST,
  QUIZ_WEB_HOST:baseVars.QUIZ_WEB_HOST,
}


// WEBPACK FOOTER //
// ./src/common/config/config.js